import VectorTileLayer from '@arcgis/core/layers/VectorTileLayer';

/**
 * Vector Tile Layer that is the background of the map
 */
export const tileLayer = new VectorTileLayer({
  url: 'https://services.geodataonline.no/arcgis/rest/services/GeocacheVector/GeocacheGraatone/VectorTileServer',
});
